import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

class InfoBlockHorizontal extends Component {
  render() {
    return (
      <Row noGutters className={this.props.className}>
        <Col>
          {this.props.title}
        </Col>
        <Col className="text-right">
          {this.props.description}
        </Col>
      </Row>
    );
  }
}

export default InfoBlockHorizontal;
